<nav id="sidebar" [class.active]="isActive">
  <!-- Sidebar Header -->
  <!-- Sidebar Links -->
  <button (click)="toggle()" type="button" id="sidebarCollapse" class="sidebar-toggle visible-reducir" nz-button nzType="text" aria-label="Abrir menú">
    <i class="fas fa-bars"></i>
  </button>
  <button type="button" (click)="toggle()" class="sidebar-close" [class.invisible-reducir]="!isActive" nz-button nzType="text" aria-label="Cerrar menú">
    <i class="fas fa-times"></i>
  </button>

  <img alt="Logo" src="assets/site_logo_white_no_border.svg" class="logo-sidebar" [class.invisible-reducir]="!isActive" />
  @if (enPaginaClientesBackOffice | async) {
  <div>
    @if (isActive) {
    <div class="my-text-menu-clientes-backoffice">
      <button
        type="button"
        aria-label="Gestión de Altas"
        [class.my-select]="rutaActual === 'BackOffice_GestionAltasClientes'"
        (click)="onGoToAdminPage('BackOffice_GestionAltasClientes')"
      >
        Gestión de Altas
      </button>
      <button
        type="button"
        aria-label="Importación de catálogos"
        [class.my-select]="rutaActual === 'BackOffice_GestionImportarCatalogos'"
        (click)="onGoToAdminPage('BackOffice_GestionImportarCatalogos')"
      >
        Importación de catálogos
      </button>
      <button
        type="button"
        aria-label="Gestión de Saldo Hermes"
        [class.my-select]="rutaActual === 'BackOffice_GestionSaldoHermes'"
        (click)="onGoToAdminPage('BackOffice_GestionSaldoHermes')"
      >
        Gestión de Saldo Hermes
      </button>
    </div>
    }
  </div>
  } @if ((enPaginaClientesBackOffice | async) !== true) {
  <div class="arbol-container">
    <dashboard-arbol [class.invisible-reducir]="!isActive" (onDblClickNode)="dblClickNodeHandler($event)"></dashboard-arbol>
  </div>
  }
</nav>
